import axios from "axios";
import {BASE_PATH} from "../services/api";

export const getRop = (calc_id) => {
    return axios.get(BASE_PATH + "/admin/get-rop/" + calc_id, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};
